<lumiron-section>
  <lumiron-section-header>
    <lumiron-section-title>Buchung</lumiron-section-title>
    <lumiron-section-summary
      >Bereit für ein unvergessliches Bubble Soccer Event? Sende uns jetzt deine Anfrage.</lumiron-section-summary
    >
  </lumiron-section-header>

  <lumiron-section-body>
    <form [formGroup]="offerForm" class="offer-form">
      <div>
        <label for="firstnameInput" class="form-label">Vorname *</label>
        <input type="text" class="form-control" id="firstnameInput" formControlName="firstname" />
      </div>
      <div>
        <label for="lastnameInput" class="form-label">Nachname *</label>
        <input type="text" class="form-control" id="lastnameInput" formControlName="lastname" />
      </div>
      <div>
        <label for="emailInput" class="form-label">E-Mail *</label>
        <input type="email" class="form-control" id="emailInput" formControlName="email" />
      </div>
      <div>
        <label for="phoneInput" class="form-label">Telefon</label>
        <input type="tel" class="form-control" id="phoneInput" formControlName="phone" />
      </div>

      <div>
        <label for="offerTypeInput" class="form-label">Angebots Typ *</label>
        <select id="offerTypeInput" class="form-select" formControlName="offerType">
          <option selected value="Betreut">Betreut</option>
          <option value="Nicht Betreut">Nicht Betreut</option>
          <option value="Kinder (Unbetreut)">Kinder (Unbetreut)</option>
        </select>
      </div>

      <div>
        <label for="dateAndTimeInput" class="form-label">Datum & Uhrzeit *</label>
        <div class="input-group">
          <input
            id="dateAndTimeInput"
            class="form-control"
            name="dp"
            [placeholder]="'dd.mm.yyyy'"
            [formControlName]="'date'"
            [minDate]="minDate"
            ngbDatepicker
            #d="ngbDatepicker"
          />
          <button class="btn btn-outline-secondary calendar-button" (click)="d.toggle()" type="button">
            <i class="bi bi-calendar3"></i>
          </button>
          <input
            id="typeahead-focus"
            type="text"
            class="form-control"
            [formControlName]="'time'"
            [placeholder]="'HH:mm'"
            [ngbTypeahead]="search"
            (focus)="focus$.next($any($event).target.value)"
            (click)="click$.next($any($event).target.value)"
            #timeTypeahead="ngbTypeahead"
            [editable]="false"
            [popupClass]="'lumiron-time-popup'"
          />
        </div>
      </div>

      <div>
        <label for="fieldInput" class="form-label">Platz *</label>
        <select id="fieldInput" class="form-select" formControlName="field">
          <option selected value="Eigener Platz">Eigener Platz</option>
          <option value="Kein eigener Platz">Kein eigener Platz</option>
        </select>
      </div>

      <div>
        @if (showDurationHours$ | async) {
        <label for="durationHoursInput" class="form-label">Dauer *</label>
        <select id="durationHoursInput" class="form-select" formControlName="durationHours">
          <option selected value="1">1 Stunde</option>
          <option value="1.5">1.5 Stunden</option>
        </select>
        }
      </div>

      <div class="total-form-control" [ngClass]="{ 'top-row': (showDurationHours$ | async) === false }">
        <label for="totalInput" class="form-label">Total</label>
        <input type="text" class="form-control" id="totalInput" formControlName="total" />
      </div>

      <div class="message">
        <label for="messageInput" class="form-label">Das wollte ich noch mitteilen</label>
        <textarea class="form-control" id="messageInput" rows="10" formControlName="message"></textarea>
      </div>

      <div class="form-check span-2">
        <input class="form-check-input" type="checkbox" id="agbInput" formControlName="agb" />
        <label class="form-check-label" for="agbInput">
          Ich habe die <a [routerLink]="'/agb'">AGBs</a> gelesen und akzeptiere sie
        </label>
      </div>

      <lumiron-button [disabled]="!offerForm.valid || sendingMessage()" (click)="sendOfferForm()">
        @if (sendingMessage()) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span role="status">senden...</span>
        } @else { Anfrage senden }
      </lumiron-button>
    </form>
  </lumiron-section-body>
</lumiron-section>
